// import LOCATION_NAMES from "@/constants/location.constants";

import type { TypeArticleWithoutUnresolvableLinksResponse } from '@/contentful/types';

// export const getRandomArticles = (articles: Article[], count = 3) => {
//     const numberOfRandom = articles.length >= count ? count : articles.length;
//     return articles.sort(() => 0.5 - Math.random()).slice(0, numberOfRandom);
// };

// export const getArticlesByCategory = async (category?: string): Promise<ArticlesByCategory> => {
//     const articlesByCategoryResponse = await fetch(`${process.env.SITE_BASE_URL}/api/articles?location=${category ?? LOCATION_NAMES.AUSTRALIA}`);
//     const articlesByCategory = await articlesByCategoryResponse.json() as ArticlesByCategory;
//     return articlesByCategory;
// }

export const paginateArticles = async (query: FilterQuery) => {
  try {
    const response = await fetch('/api/articles', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ query })
    });
    if (!response.ok) {
      throw new Error('Error retrieving articles');
    }
    const data = (await response.json()) as {
      articles: TypeArticleWithoutUnresolvableLinksResponse[];
    };
    return data.articles;
  } catch (error) {
    console.error('Error retrieving articles:', error);
    return [];
  }
};

export const getArticlesByAuthor = async (
  author: string,
  skip: number,
  limit: number
) => {
  try {
    const response = await fetch(`/api/articles`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        author: {
          author,
          skip,
          limit
        }
      })
    });
    if (!response.ok) {
      throw new Error('Error retrieving articles');
    }
    const data = (await response.json()) as {
      articles: TypeArticleWithoutUnresolvableLinksResponse[];
    };
    return data;
  } catch (error) {
    console.error('Error retrieving articles:', error);
    return { articles: [], total: 0 };
  }
};

type SearchResponse = {
  docs: TypeArticleWithoutUnresolvableLinksResponse[];
  nextPage: number;
};

export const searchArticles = async (
  query: QueryStringParameters
): Promise<SearchResponse> => {
  try {
    const response = await fetch('/api/articles', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      body: JSON.stringify({ search: query })
    });
    if (!response.ok) {
      throw new Error('Error retrieving articles');
    }
    const data = (await response.json()) as SearchResponse;
    return data;
  } catch (error) {
    console.error('Error retrieving articles:', error);
    return {
      docs: [],
      nextPage: 0
    };
  }
};

export const getArticleBySlug = async (
  query: PreviewQuery
): Promise<TypeArticleWithoutUnresolvableLinksResponse | null> => {
  try {
    const response = await fetch('/api/articles', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      body: JSON.stringify({ preview: query })
    });
    if (!response.ok) {
      throw new Error('Error retrieving articles');
    }
    const data = (await response.json()) as {
      article: TypeArticleWithoutUnresolvableLinksResponse;
    };
    return data.article;
  } catch (error) {
    console.error('Error retrieving articles:', error);
    return null;
  }
};

export const getRandomArticles = (
  articles: TypeArticleWithoutUnresolvableLinksResponse[],
  count = 3
) => {
  const numberOfRandom = articles.length >= count ? count : articles.length;
  return articles.sort(() => 0.5 - Math.random()).slice(0, numberOfRandom);
};
